import React, { Fragment, HTMLAttributes } from "react";
import { ILocationData } from "@/sg-kohderekisterit/IKohderekisteri";

export interface ILocationNameProps extends HTMLAttributes<HTMLSpanElement> {
    as?: any;
    locationId?: ILocationData["id"];
    data?: ILocationData
}

export const LocationName: React.FC<ILocationNameProps> = ({ locationId, data }) => {


    return (
        <Fragment>
            Unconfigure LocationName: {locationId}
        </Fragment>
    )
}; 